import Layout from '../../components/Layout';
import Head from 'next/head';
import Slider from 'react-slick';
import axiosInstance from '../../config/axios';
import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useRouter } from "next/router";
import sanitize from '../../helpers/sanitize';

const Career = ({
	careers,
	career_recruitment,
	career_recruitment_image,
	career_tnd,
	career_tnd_image,
	career_banner,
	testimonials,
}) => {
	const settings = {
		autoplay: true,
		speed: 1000,
		autoplaySpeed: 4000,
		// slidesToShow: 1,
	};

	const createMarkup = (html) => ({ __html: sanitize(html) });

	const banner = career_banner?.includes(' ')
		? career_banner?.replaceAll(' ', '%20')
		: career_banner;

	useEffect(() => {
		ReactGA.pageview(window.location.pathname + window.location.search);
	}, []);
	const router = useRouter();
		const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;
	    

	return (
		<>
			<Layout>
				<Head>
				<link rel="canonical" href={canonicalUrl} />
					<title>Careers at Kilimanjaro | Jobs & Opportunities </title>
					<meta
						name='description'
						content='Explore career opportunities at Kilimanjaro Restaurants. Join a dynamic team, develop your skills, and build a rewarding career in the restaurant and hospitality industry.'
					/>
				</Head>
				<header className="store-header">
  <img
    src={banner}
    alt="Career Banner"
    loading="eager"
    className="store-header__bg img-fluid"
  />

  <h1 className="visually-hidden">
    Careers at Kilimanjaro
  </h1>
</header>
				<section className='contact-us store-location career'>
					<div className='container'>
						<div className='row mb-5 pb-5'>
							<div className='col-md-6'>
								<h4>Careers</h4>
								<div dangerouslySetInnerHTML={createMarkup(careers)}></div>
							</div>
							<div className='col-md-6'>
								<h4>Testimonials</h4>
								<Slider {...settings}>
									{testimonials
										?.filter((tes) => tes.user_name)
										.map((testimonial) => {
											return (
												<div key={testimonial.id} className='testimonial'>
													<div dangerouslySetInnerHTML={createMarkup(testimonial.testimony)}></div>
													{testimonial.user_name && (
														<p className='testimonial-name'>&ndash;{testimonial.user_name}</p>
													)}
												</div>
											);
										})}
								</Slider>
							</div>
						</div>
						<div className='row mt-5 pb-5'>
							<div className='col-md-6'>
								<h4>Recruitment</h4>
								<div dangerouslySetInnerHTML={createMarkup(career_recruitment)}></div>
							</div>
							<div className='col-md-6'>
								<img className='img-fluid' src={career_recruitment_image} alt='recruitment' loading="eager" />
							</div>
						</div>
						<div className='row mt-5 pt-5'>
							<div className='col-md-6'>
								<h4>Training &amp; development</h4>
								<div dangerouslySetInnerHTML={createMarkup(career_tnd)}></div>
							</div>
							<div className='col-md-6'>
								<img className='img-fluid' src={career_tnd_image} alt='career image'  loading="eager" />
							</div>
						</div>
					</div>
				</section>
			</Layout>
		</>
	);
};

Career.getInitialProps = async () => {
	try {
		const {
			data: {
				data: {
					careers,
					career_recruitment,
					career_recruitment_image,
					career_tnd,
					career_tnd_image,
					career_banner,
				},
			},
		} = await axiosInstance.get('settings');
		const {
			data: { data },
		} = await axiosInstance.get('testimonials');
		return {
			careers,
			career_recruitment,
			career_recruitment_image,
			career_tnd,
			career_tnd_image,
			career_banner,
			testimonials: data,
		};
	} catch (e) {
		
		return {};
	}
};

export default Career;
